let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("coJiW"), load("h4Nf7"), load("2Cftu"), load("4i0CB"), load("lk4cE")]).then(() => parcelRequire('3aGPB'));